const firebaseConfig = {
    apiKey: "AIzaSyBGjAzOPzq8spbM8nDpRCpl3u8jN4vA04E",
    authDomain: "essentielfoot.firebaseapp.com",
    databaseURL: "https://essentielfoot.firebaseio.com",
    projectId: "essentielfoot",
    storageBucket: "essentielfoot.appspot.com",
    messagingSenderId: "804766257257",
    appId: "1:804766257257:web:48e49a051a97f478dd12f8",
    measurementId: "G-JX9CNGB79H"
}

export default firebaseConfig